module.exports = {"mysql_user":"root","mysql_password":"ldpa123","mail_user":"maildb","mail_password":"Socalld2020%","PRODUCTION":true,"URL":"https://portal.ldpa.us:8080","API":"https://backend.ldpa.us","MYSQL_IP":"10.20.31.66","EMAIL_MYSQL_IP":"10.20.31.62","NODEPORT":8443,"sshData":{"host":"10.20.31.62","user":"maildb","pass":"socalBC2020%"}}


//////////////////
// WEBPACK FOOTER
// ./clientconfig.json
// module id = 889
// module chunks = 0